import { createContext, useContext, useState } from 'react';

const SearchFormContext = createContext<any>({
    selectedSubscriber: null,
    setSelectedSubscriber: () => {},
    searchParamsSubscriber: null,
    setSearchParamsSubscriber: () => {},
    searchParamsContracts: null,
    setSearchParamsContracts: () => {},
    selectedContract: null,
    setSelectedContract: () => {},
    searchParamsAffilie: null,
    setSearchParamsAffilie: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function SearchFormProvider({ children }: Props) {
    const [selectedSubscriber, setSelectedSubscriber] = useState(null);
    const [searchParamsSubscriber, setSearchParamsSubscriber] = useState<SearchParams>(INITIAL_SEARCH_PARAMS_SUB);
    const [searchParamsContracts, setSearchParamsContracts] = useState<SearchParams>(INITIAL_SEARCH_PARAMS_CONTRACT);
    const [selectedContract, setSelectedContract] = useState(null);
    const [searchParamsAffilie, setSearchParamsAffilie] = useState<SearchParams>(INITIAL_SEARCH_PARAMS_AFFILIE);

    const resetSearchParamsContracts = () => {
        setSearchParamsContracts(INITIAL_SEARCH_PARAMS_CONTRACT);
    };

    const resetSearchParamsAffilie = () => {
        setSearchParamsAffilie(INITIAL_SEARCH_PARAMS_AFFILIE);
    };

    return (
        <SearchFormContext.Provider
            value={{
                selectedSubscriber,
                setSelectedSubscriber,
                searchParamsSubscriber,
                setSearchParamsSubscriber,
                searchParamsContracts,
                setSearchParamsContracts,
                resetSearchParamsContracts,
                selectedContract,
                setSelectedContract,
                searchParamsAffilie,
                setSearchParamsAffilie,
                resetSearchParamsAffilie,
            }}
        >
            {children}
        </SearchFormContext.Provider>
    );
}

export const useSearchFormContext = () => useContext(SearchFormContext);

interface SearchParams {
    page: number;
    pageSize: number;
    sortBy: { id: string; desc: boolean }[];
    search: any[];
}

const INITIAL_SEARCH_PARAMS_SUB: SearchParams = {
    page: 1,
    pageSize: 10,
    sortBy: [],
    search: [],
};

const INITIAL_SEARCH_PARAMS_CONTRACT: SearchParams = {
    page: 1,
    pageSize: 10,
    sortBy: [],
    search: [],
};

const INITIAL_SEARCH_PARAMS_AFFILIE: SearchParams = {
    page: 1,
    pageSize: 10,
    sortBy: [],
    search: [],
};
